import Component from 'flarum/common/Component';
import Switch from 'flarum/common/components/Switch';

export default class JeepytaCheckbox extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    // Load the initial state of the checkbox from the user's preferences.
    this.isEnabled = this.attrs.user.data.attributes.preferences.jeepyta_enabled || false;
  }
  view() {
    return m('div', [
      Switch.component({
        state: this.attrs.user.data.attributes.preferences.jeepyta_enabled,
        onchange: (value) => this.toggleFeature(value)
      }, 'JeepyTA: enable generating AI answers to my posts')
    ]);
  }


  toggleFeature(value) {
    // Logic to update user preference via API
    this.attrs.user.savePreferences({ jeepyta_enabled: value });
  }
}
